module.exports = __webpack_public_path__ + "media/ad_preview/wral-fdd39d54.png";